import { render } from "./code-viewer.vue?vue&type=template&id=1043a02c&scoped=true"
import script from "./code-viewer.vue?vue&type=script&lang=js"
export * from "./code-viewer.vue?vue&type=script&lang=js"

import "./code-viewer.vue?vue&type=style&index=0&id=1043a02c&scoped=true&lang=css"
import "./code-viewer.vue?vue&type=style&index=1&id=1043a02c&lang=css"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1043a02c"]])

export default __exports__